import React from 'react'
import "./SummaryPanel.css"

const SummaryPanel = ({ summary }) => {
  return (
    <div className="reports-panel">
      <h5>Executive Summary</h5>

      <hr />

      {summary ? (
        <div dangerouslySetInnerHTML={{ __html: summary }} />
      ) : (
        <p>No summary available</p>
      )}

    </div>
  )
}

export default SummaryPanel
